/*eslint-disable @typescript-eslint/strict-boolean-expressions */
import { createAppStore } from '@mobileStore/createAppStore';

import { MobileOfficeDetail, UserViewModel } from './types';

export type UserState = {
  user: UserViewModel;
  officeDetail: MobileOfficeDetail | null;
  isLoading: boolean;
  isError: boolean;
  loggedIn: boolean;
};

const [mobileUserStore, setMobileUserStore] = createAppStore<UserState>(
  {
    user: {} as UserViewModel,
    officeDetail: null,
    isLoading: true,
    isError: false,
    loggedIn: false,
  },
  'mobileUserStore',
);

// @ts-expect-error We want to expose the user store.
window.user = { mobileUserStore, setMobileUserStore };

export { setMobileUserStore, mobileUserStore };
